import { animate, state, style, transition } from '@angular/animations';

export const widthChangeState = (from: string, to: string) => [
  state('from', style({ width: from })),
  state('to', style({ width: to })),
  transition('from <=> to', [animate('0.2s ease')]),
];
